module.exports = __webpack_public_path__ + "img/cursive-workbook_B0991GDVK3.e0a35765.jpg";